exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hour-overview[data-v-42c19e3c]{color:#404040}.hour-overview .title[data-v-42c19e3c]{font-weight:700}", ""]);

// exports
